import { render, staticRenderFns } from "./VendorSignup.vue?vue&type=template&id=6f9a8acc&scoped=true&"
import script from "./VendorSignup.vue?vue&type=script&lang=js&"
export * from "./VendorSignup.vue?vue&type=script&lang=js&"
import style0 from "./VendorSignup.vue?vue&type=style&index=0&id=6f9a8acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a8acc",
  null
  
)

export default component.exports